import React, { useEffect } from 'react';
import type { Settings } from '../types/course';

interface FaviconManagerProps {
  settings: Settings;
}

export function FaviconManager({ settings }: FaviconManagerProps) {
  useEffect(() => {
    // Mettre à jour le favicon
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = settings.favicon || '/vite.svg'; // Utiliser le favicon par défaut si non défini
    document.head.appendChild(link);
  }, [settings.favicon]);

  return null; // Ce composant ne rend rien visuellement
}